import React, { FC, useState } from "react";
import { Button, Input } from "antd";
import { getLanguageName } from "../../utils/languageUtils";
import "./EpisodeDrawer.scss";

interface EpisodeInfo {
  name: string;
  sourceLanguage: string;
  targetLanguage: string;
  needRemovalSubtitle: boolean;
}

interface Speaker {
  id: number;
  speaker_name: string;
  description?: string;
}

interface CharacterProfile {
  name: string;
  description: string;
}

interface EpisodeDrawerProps {
  episodeInfo: EpisodeInfo;
  speakersData: Speaker[];
  speakersLoading: boolean;
  seriesName?: string | null;
  characterProfiles?: CharacterProfile[]; // 角色信息数组（优先显示）
}

export const EpisodeDrawer: FC<EpisodeDrawerProps> = ({
  episodeInfo,
  speakersData,
  speakersLoading,
  seriesName,
  characterProfiles
}) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerAnimating, setDrawerAnimating] = useState(false);
  const [drawerOpening, setDrawerOpening] = useState(false);

  // 切换抽屉显示状态
  const toggleDrawer = () => {
    if (drawerVisible) {
      setDrawerAnimating(true);
      const drawerElement = document.querySelector('.episode-drawer');
      const overlayElement = document.querySelector('.drawer-overlay');

      if (drawerElement && overlayElement) {
        drawerElement.classList.add('slide-out');
        overlayElement.classList.add('fade-out');

        setTimeout(() => {
          setDrawerVisible(false);
          setDrawerAnimating(false);
          setDrawerOpening(false);
          drawerElement.classList.remove('slide-out');
          overlayElement.classList.remove('fade-out');
        }, 400);
      } else {
        setDrawerVisible(false);
        setDrawerAnimating(false);
        setDrawerOpening(false);
      }
    } else {
      setDrawerVisible(true);
      setDrawerAnimating(false);
      // 使用 requestAnimationFrame 确保在下一帧添加 visible 类，触发 transition
      requestAnimationFrame(() => {
        setDrawerOpening(true);
      });
    }
  };

  return (
    <>
      {/* 抽屉按钮 */}
      <Button
        type="default"
        className="drawer-toggle-btn"
        onClick={toggleDrawer}
        icon={<i className="iconfont icon-shouqicebianlan"></i>}
      />

      {/* 剧集信息抽屉 */}
      {drawerVisible && (
        <div className={`drawer-overlay ${drawerAnimating ? 'fade-out' : ''}`}>
          <div
            className={`episode-drawer ${drawerOpening ? 'visible' : ''} ${drawerAnimating ? 'slide-out' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="drawer-header">
              <h3>剧集信息</h3>
              <Button
                type="text"
                className="drawer-close-btn"
                onClick={toggleDrawer}
                icon={<i className="fas fa-times"></i>}
              />
            </div>
            <div className="drawer-content">
              <div className="form-item">
                <label>剧集名称</label>
                <Input
                  value={seriesName || episodeInfo.name || ''}
                  disabled
                  className="disabled-input"
                />
              </div>
              <div className="form-item">
                <label>源语言</label>
                <Input
                  value={getLanguageName(episodeInfo.sourceLanguage) || episodeInfo.sourceLanguage}
                  disabled
                  className="disabled-input"
                />
              </div>
              <div className="form-item">
                <label>字幕擦除</label>
                <div className="subtitle-toggle-wrapper">
                  {(() => {
                    
                    return (
                      <div
                        className={`subtitle-toggle ${episodeInfo.needRemovalSubtitle ? 'active' : ''}`}
                        style={{ cursor: 'not-allowed', opacity: 0.7 }}
                      >
                        <div className="toggle-handle"></div>
                      </div>
                    );
                  })()}
                </div>
              </div>

              <div className="form-item vertical-layout">
                <label>主要角色</label>
                {speakersLoading ? (
                  <div className="synopsis-role">加载中...</div>
                ) : characterProfiles && characterProfiles.length > 0 ? (
                  characterProfiles.map((character, index) => (
                    <div key={character.name || index} className="synopsis-role">
                      {character.name}：{character.description || ''}
                    </div>
                  ))
                ) : speakersData.length > 0 ? (
                  speakersData.map((speaker, index) => (
                    <div key={speaker.id || index} className="synopsis-role">
                      {speaker.speaker_name}：{speaker.description || ''}
                    </div>
                  ))
                ) : (
                  <div className="synopsis-role">暂无角色信息</div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};



